module.exports = __webpack_public_path__ + "img/list-img1.f2e2d706.png";